<template>
  <v-row no-gutters justify="center" class="ma-4 pa-0">
    <v-col cols="12" lg="12" xl="12">
      <v-card elevation="0" color="transparent" width="100%" style="direction: ltr">
        <v-row justify="center" class="mb-4">

          <!--          <v-otp-input-->
          <!--              autofocus-->
          <!--              v-model="numberInput"-->
          <!--              length="4"-->
          <!--          ></v-otp-input>-->

          <!--          <v-text-field label="رمز عبور" dense type="password" append-icon="mdi-lock"-->
          <!--                        id="edit_pass"-->
          <!--                        :error-messages="errors.verify.password === undefined ? [] : errors.verify.password"-->
          <!--                        v-if="!registered && !forget_password && !verified && methodSelected=='pass'"-->
          <!--                        hint="حداقل 8 کاراکتر"-->
          <!--                        :rules="[rules.required, rules.min]"-->
          <!--                        autofocus-->
          <!--                        v-model="loginpass" outlined/>-->


          <v-text-field v-model="numberInput" dense class=" mt-1 input-model" outlined label="کد تایید"
                        autofocus
                        prepend-inner-icon="mdi-form-textbox-password"
                        hint="کد تایید ارسالی را وارد کنید"
                        @keypress="isNumberKey"
                        maxlength="4">
          </v-text-field>


          <v-btn block color="primary"

                 rounded
                 :loading="loading"
                 class="white--text"
                 @click="()=>{
                     this.loading=true
                     this.$root.$emit('Step2', this.numberInput);
                 }">
            <v-icon class="mr-1">mdi-login</v-icon>
            ورود

          </v-btn>


          <!--          <v-col class="px-2 input-model" cols="2" v-for="(y, i) in 4" :key="`in${i}`">-->
          <!--            <v-text-field type="text" :id="`input-${i}`" hide-details readonly/>-->
          <!--          </v-col>-->

        </v-row>
        <!--        <v-row id="keypad-column-holder">-->

        <!--          <v-col cols="4" class="keypad-column" v-for="(x ,i) in numbers" :key="`btn-${i}`">-->
        <!--            <v-btn v-model="x.model" fab :color="btnColor" v-text="x.value" elevation="0"-->
        <!--                   @click="keypadInput(x.value)"/>-->
        <!--          </v-col>-->

        <!--          <v-col cols="4" class="keypad-column">-->
        <!--          </v-col>-->

        <!--          <v-col cols="4" class="keypad-column">-->
        <!--            <v-btn fab :color="btnColor" v-text="0" elevation="0"-->
        <!--                   @click="keypadInput(0)"/>-->
        <!--          </v-col>-->

        <!--          <v-col cols="4" class="keypad-column">-->
        <!--            <v-btn fab :color="btnColor" elevation="0" @click="keypadInput(-1)">-->
        <!--              <v-icon>mdi-backspace-outline</v-icon>-->
        <!--            </v-btn>-->
        <!--          </v-col>-->

        <!--        </v-row>-->

      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "numKeypad",
  props: ['loading','value'],
  model:{
    prop:'value',
    event:'input'
  },
  data: () => ({
    btnColor: '#dedbec',
    numberInput: null,
    numbers: [
      {value: 1, model: 'num1'},
      {value: 2, model: 'num2'},
      {value: 3, model: 'num3'},
      {value: 4, model: 'num4'},
      {value: 5, model: 'num5'},
      {value: 6, model: 'num6'},
      {value: 7, model: 'num7'},
      {value: 8, model: 'num8'},
      {value: 9, model: 'num9'},
    ],
    code: [],
    vInputs: [],
  }),

  watch: {
    numberInput(val) {
      this.$emit('input', val)
    }
  },

  mounted() {
    // document.addEventListener('keyup', this.fillInput);
  },
  // watch: {
  //   numberInput(val) {
  //     console.log(val.length)
  //     if (val.length ==4){
  //       this.$root.$emit('Step2', this.numberInput);
  //     }
  //   }
  // },

  methods: {
    fillInput(e) {

      let key = parseInt(e.key);

      let inputArray = [];
      let vInput = [];

      vInput = document.getElementsByClassName('v-input');

      for (let i = 0; i < 4; i++) {
        inputArray.push(document.getElementById(`input-${i}`));
        this.vInputs.push(vInput[i]);
      }

      if (key >= 0 && key <= 9) {
        for (let i = 0; i < 4; i++) {
          if (inputArray[i].value.length <= 0) {
            if (i > 0)
              vInput[i - 1].classList.remove("v-input--is-focused", 'primary--text');
            vInput[i].classList.add("v-input--is-focused", 'primary--text');
            inputArray[i].value = key;
            this.code.push(key);
            if (i === 3) {
              this.verifyLogin();
            }
            break;
          }
        }
      }

      if (e.key === "Backspace") {
        this.code = [];

        inputArray.reverse();
        this.vInputs.reverse();

        let array = this.code.reverse();

        for (let i = 0; i < 4; i++) {
          if (inputArray[i].value.length > 0) {
            inputArray[i].value = '';
            array.splice(0, 1)
            // break;
          }
        }
        if (vInput.length > 0) {
          vInput[1].classList.remove("v-input--is-focused", 'primary--text');
          vInput[2].classList.remove("v-input--is-focused", 'primary--text');
          vInput[3].classList.remove("v-input--is-focused", 'primary--text');
          vInput[0].classList.add("v-input--is-focused", "primary--text");
          this.code = array.reverse();
        }

        this.vInputs.reverse();
      }
    },

    keypadInput(num) {
      let inputArray = [];
      let vInput = [];

      vInput = document.getElementsByClassName('v-input');

      for (let i = 0; i < 4; i++) {
        inputArray.push(document.getElementById(`input-${i}`));
        this.vInputs.push(vInput[i]);
      }

      if (num >= 0 && num <= 9) {
        for (let i = 0; i < 4; i++) {
          if (inputArray[i].value.length <= 0) {
            this.code.push(num);
            inputArray[i].value = num;
            if (i > 0)
              vInput[i - 1].classList.remove("v-input--is-focused", 'primary--text');
            vInput[i].classList.add("v-input--is-focused", 'primary--text');
            inputArray[i].style.textAlign = 'center';
            if (i === 3) {
              this.verifyLogin();
            }
            break;
          }
        }
      }

      if (num === -1) {

        this.code = [];

        inputArray.reverse();
        this.vInputs.reverse();

        let array = this.code.reverse();

        for (let i = 0; i < 4; i++) {
          if (inputArray[i].value.length > 0) {
            inputArray[i].value = '';
            array.splice(0, 1)
            // break;
          }
        }
        if (vInput.length > 0) {
          vInput[1].classList.remove("v-input--is-focused", 'primary--text');
          vInput[2].classList.remove("v-input--is-focused", 'primary--text');
          vInput[3].classList.remove("v-input--is-focused", 'primary--text');
          vInput[0].classList.add("v-input--is-focused", "primary--text");
          this.code = array.reverse();
        }

        this.vInputs.reverse();
      }
    },

    verifyLogin() {

      let code = '';
      for (let i = 0; i < this.code.length; i++) {
        code += '' + this.code[i];
      }

      this.$root.$emit('Step2', code);

      setTimeout(() => {
        this.keypadInput(-1);
        this.fillInput(-1);
      }, 300)
    },
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.fillInput);
  },
}
</script>

<style scoped>
.input-model >>> label.v-label--active {
  right: -0px !important;
}

.keypad-column {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 70px;
}

.keypad-column >>> .v-btn {
  font-size: 1.275rem;
}

.keypad-column >>> .v-btn:before {
  background-color: unset !important;
}
</style>
